export enum AadGroupSearchScenario {
    All = 'all',
    AzureAssignable = 'AzureAssignable',
    AppRoleAssignable = 'AppRoleAssignable',
    GroupUpdate = 'GroupUpdate',
}